import angular from 'angular';
import 'angular-bootstrap';
import '../../locale';
import './levelRebusesServices';

const levelRebusesControllers = angular.module('applicationModule.levelRebusesControllers', ['applicationModule.levelRebusesServices', 'ui.bootstrap']);

levelRebusesControllers.controller('LevelRebusesController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'LevelRebus', 'growl', 'AppsoupAPI', 'Permissions', '$modal', function ($scope, $rootScope, $stateParams, NgTableParams, LevelRebus, growl, AppsoupAPI, Permissions, $modal) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('level_rebuses');
    $scope.app_id = $stateParams.application_id;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return LevelRebus.getList($scope.app_id, params._params).then(function (response) {
                params.total(response.levelRebuses.total);
                params.count(response.levelRebuses.per_page);
                params.page(response.levelRebuses.current_page);
                return response.levelRebuses.data;
            }).finally(function () {
                $scope.isLoading = false;
            });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.newLevelRebus = function () {
        openModal();
    };

    $scope.editLevelRebus = function (levelRebusId, index) {
        openModal(levelRebusId, index);
    };

    function openModal(levelRebusId, index) {
        var modalInstance = $modal.open({
            templateUrl: 'views/application/levelrebuses/levelRebus.tpl.html',
            controller: 'LevelRebusModalController',
            resolve: {
                levelRebusId: function () {
                    return levelRebusId;
                }
            }
        });
        modalInstance.result.then(function (levelRebus) {
            if (angular.isDefined(index)) {
                $scope.tableParams.data[index] = levelRebus;
            } else {
                $scope.tableParams.data.push(levelRebus);
            }
        }).catch(() => {});
    }

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeLevelRebus = function (id, index) {
        LevelRebus.remove(id, $scope.app_id).then(function (result) {
            let data = result.data;

            if (data.success) {
                growl.success('MODULES.LEVEL_REBUSES.SUCCESS.DELETED');
                $scope.tableParams.data.splice(index, 1);
            } else {
                growl.error('MODULES.LEVEL_REBUSES.ERROR.DELETED');
            }
        });
    };
}]);

levelRebusesControllers.controller('LevelRebusModalController', ['$scope', '$rootScope', '$stateParams', '$state', 'LevelRebus', 'levelRebusId', 'growl', 'Permissions', '$modalInstance', function ($scope, $rootScope, $stateParams, $state, LevelRebus, levelRebusId, growl, Permissions, $modalInstance) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('level_rebuses');
    var app_id = $stateParams.application_id;

    $scope.editMode = false;
    $scope.levelRebus = {
        app_id: app_id
    };

    if (levelRebusId) {
        $scope.editMode = true;
        $scope.isLoading = true;

        LevelRebus.get(levelRebusId).then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.levelRebus = data.levelRebus;
            } else {
                growl.error('MODULES.LEVEL_REBUSES.' + data.error);
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.levelRebusForm.$valid) {
            $scope.isLoading = true;
            LevelRebus.save($scope.levelRebus, $scope.editMode).then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.LEVEL_REBUSES.SUCCESS.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                    $modalInstance.close(data.levelRebus);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.LEVEL_REBUSES.ERROR.' + ($scope.editMode ? 'EDITED' : 'CREATED'));
                    }
                }
            }).finally(function () {
                $scope.isLoading = false;
            });
        }
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'level_number': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'bombs': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'answers_to_unlock': [{type: '$invalid', msg: 'ERROR.REQUIRED'}],
        'color': [{type: '$invalid', msg: 'ERROR.REQUIRED'}]
    };

}]);

export default levelRebusesControllers;
